import script from "./PerformanceComp.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceComp.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceComp.vue?vue&type=style&index=0&id=681eb31a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681eb31a"]])

export default __exports__